const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: HomeIcon, current: true, feature: 'nav_dashboard' },
  { name: 'Chat', href: '/chatdashboard', icon: ChatBubbleBottomCenterIcon, current: false, feature: 'nav_chat' },
  { name: 'My Profile', href: '/myprofile', icon: UserIcon, current: false, feature: 'nav_profile' },
  { name: 'Projects', href: '/project-management', icon: ChartBarSquareIcon, current: false, feature: 'nav_projects' },
    { name: 'Finances', href: '/finances', icon: CurrencyPoundIcon, current: false, feature: 'nav_finances' },

  { name: 'Sales / Project CRM', href: '/customercrm', icon: UserGroupIcon, current: false, feature: 'nav_customer_crm' },
  { name: 'Task Manager', href: '/taskcalendar', icon: CalendarDateRangeIcon, current: false, feature: 'nav_task_manager' },
  { name: 'Recruitment', href: '/recruitment', icon: BriefcaseIcon, current: false, feature: 'nav_recruitment' },
  { name: 'Admin Tasks', href: '/admin-tasks', icon: DocumentCheckIcon, current: false, feature: 'nav_admin_tasks' },
  { name: 'Training', href: '/training', icon: AcademicCapIcon, current: false, feature: 'nav_training' },
  { name: 'Organization', href: '/organizationaltree', icon: ScaleIcon, current: false, feature: 'nav_organization' },
  { name: 'Users', href: '/users', icon: UserGroupIcon, current: false, feature: 'nav_users' },
  { name: 'Billing', href: '/billing', icon: WalletIcon, current: false, feature: 'nav_billing' },
  { name: 'Docs', href: '/support', icon: DocumentMagnifyingGlassIcon, current: false, feature: 'nav_docs' },
  { name: 'Productivity Insights', href: '/productivity-insights', icon: MagnifyingGlassCircleIcon, current: false, feature: 'nav_productivity_insights' },
  { name: 'Log Out', href: '/logout', icon: PowerIcon, current: false, feature: 'nav_logout' },
];


import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import { useEffect } from 'react';
import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/20/solid'
import TaskManager from './taskmanager';



import {
  Bars3Icon,
  CalendarIcon,
  DocumentDuplicateIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon,
  UserIcon,
  CalendarDaysIcon,
  BellIcon,
  ArrowPathRoundedSquareIcon,
  Cog6ToothIcon,
  WalletIcon,
  ChartBarIcon,
  DocumentArrowUpIcon,
  PowerIcon,
  ClipboardDocumentCheckIcon,
  DocumentCheckIcon,
  CalendarDateRangeIcon,
  ChartBarSquareIcon,
  QuestionMarkCircleIcon,
  LightBulbIcon,
  BriefcaseIcon,
  ExclamationTriangleIcon,
  ChatBubbleBottomCenterIcon, 
  AcademicCapIcon,
  EnvelopeOpenIcon 


} from '@heroicons/react/20/solid';
import { BookOpenIcon, CurrencyPoundIcon, DocumentMagnifyingGlassIcon, MagnifyingGlassCircleIcon, ScaleIcon, UserGroupIcon } from '@heroicons/react/24/solid';
import HeatMap  from './heatmap';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}



export default function TrainingStats() {

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const token = localStorage.getItem('token');

  const [trainingStats, setTrainingStats] = useState([]); // Array of training result objects for staff who took the quiz
  const [missingTraining, setMissingTraining] = useState([]); // Array of objects for staff missing from a training
  const [teamMembers, setTeamMembers] = useState(0);
  const [loading, setLoading] = useState(true);
  const [graph, setGraph] = useState(null);
  const [trainingTitles, setTrainingTitles] = useState([]);
  const [openRec, setOpenRec] = useState(false);
  const [taskCounts, setTaskCounts] = useState({});
  
  
  const [handleReminder, setHandleReminder] = useState(false);

  // This state controls which training card is "open" (showing details)
  const [openTrainingId, setOpenTrainingId] = useState(null);

  useEffect(() => {
    // Fetch training statistics from your API endpoint
    const fetchStats = async () => {
      try {
        const response = await fetch('https://api.insightos.co.uk/api/trainingstatsteam', {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            },
            credentials: 'include',

        });


        const data = await response.json();
        if (data.success) {
          setTrainingStats(data.data);

          // find all the unique trainingTitles

          const trainingTitles = [...new Set(data.data.map((item) => item.trainingTitle))];

          // turn trainingTitles into an array of objects with a title property

          const trainingTitle = trainingTitles.map((title) => ({ title }));



          setTrainingTitles(trainingTitle.length);

          setMissingTraining(data.missingTraining);
          setTeamMembers(data.teamMembers);
        }
      } catch (error) {
        console.error('Error fetching training stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);


  
 


       


  // Group the trainingStats by trainingId so that each card represents one training course.
  // Each group will have an array of results (each result represents one staff's attempt(s)).
  const groupedTrainings = trainingStats.reduce((acc, curr) => {
    const { trainingId, trainingTitle } = curr;
    if (!acc[trainingId]) {
      acc[trainingId] = { trainingTitle, results: [] };
    }
    acc[trainingId].results.push(curr);
    return acc;
  }, {});

  const trainingCards = Object.keys(groupedTrainings).map((trainingId) => ({
    trainingId,
    trainingTitle: groupedTrainings[trainingId].trainingTitle,
    results: groupedTrainings[trainingId].results,
  }));

  // For a given training course, find the list of staff who have taken it
  // and the list of staff missing it.
  const getTrainingDetails = (trainingId) => {
    // Staff who took the quiz for this training
    const taken = groupedTrainings[trainingId].results;
    // Missing: filter the missingTraining array by matching trainingId.
    const missing = missingTraining.filter((m) => m.trainingId == trainingId);
    return { taken, missing };
  };

  if (loading) {
    return <div className="p-6 text-slate-600">Loading training statistics...</div>;
  }

  
  
  

  
  const stats = [
    { id: 1, name: 'Staff Members', stat: teamMembers, icon: UsersIcon, change: '122', changeType: 'increase' },
    { id: 2, name: 'Courses', stat: trainingTitles, icon: EnvelopeOpenIcon, change: '5.4%', changeType: 'increase' },
  ]
  
    

   


  return (
  <>
  <div data-component="training-stats" className="min-h-screen bg-gradient-to-br from-slate-100 via-indigo-50/40 to-cyan-50/40">
    
    
  

    <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-white transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
      />

      <div className="fixed inset-0 flex">
        <DialogPanel
          transition
          className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
        >
          <TransitionChild>
            <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
              <button
                data-component="training-stats-sidebar"
                data-feature="close"
                type="button"
                onClick={() => setSidebarOpen(false)}
                className="-m-2.5 p-2.5"
              >
                <span className="sr-only">Close sidebar</span>
                <XMarkIcon aria-hidden="true" className="size-6 text-white" />
              </button>
            </div>
          </TransitionChild>

          <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gradient-to-b from-indigo-900 from-10% via-sky-500 via-30% to-emerald-500 to-90% px-6 pb-2 ring-1 ring-white/10">
            <div className="flex h-16 shrink-0 items-center">
              <img
                alt="Your Company"
                src="2.png"
                className="h-10 w-auto rounded-full bg-gray-800"
              />
            </div>
            <nav className="flex flex-1 flex-col">
              <ul role="list" className="-mx-2 flex-1 space-y-1">
                {navigation.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.href}
                      className={classNames(
                        item.current
                          ? 'bg-blue-700 text-white'
                          : 'text-white hover:bg-blue-700 hover:text-white',
                        'group relative flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                      )}
                    >
                      <item.icon aria-hidden="true" className="size-6 shrink-0" />
                      {/* Tooltip */}
                        {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </DialogPanel>
      </div>
    </Dialog>

    {/* Static sidebar for desktop */}
    <div className="hidden lg:fixed lg:inset-y-0 lg:left-0 lg:z-50 lg:block lg:w-20 lg:overflow-y-auto lg:bg-gradient-to-b from-indigo-900 from-10% via-sky-500 via-30% to-emerald-500 to-90% lg:pb-4">
      <div className="flex h-16 shrink-0 items-center justify-center">
        <img
          alt="Your Company"
          src="2.png"
          className="h-10 w-auto rounded-full bg-gray-800"
        />
      </div>
      <nav className="mt-8">
        <ul role="list" className="flex flex-col items-center space-y-1">
          {navigation.map((item) => (
            <li key={item.name}>
              <Link
                to={item.href}
                className={classNames(
                  item.current
                    ? 'bg-white text-blue-700'
                    : 'text-white hover:bg-blue-700 hover:text-white',
                  'group relative flex items-center gap-x-3 rounded-md p-3 text-sm font-semibold',
                )}
              >
                <item.icon aria-hidden="true" className="h-6 w-6 shrink-0" />
                {/* Tooltip */}
                <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 scale-0 rounded-md bg-gray-700 px-3 py-1 text-xs text-white shadow-lg transition-all duration-150 group-hover:scale-100">
{item.name}
</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>

    <div className="sticky top-0 z-40 flex items-center gap-x-6 bg-gradient-to-l from-indigo-900 from-10% via-sky-500 via-30% to-emerald-500 to-90% px-4 py-4 shadow-sm sm:px-6 lg:hidden">
      <button
        data-component="training-stats-sidebar"
        data-feature="open"
        type="button"
        onClick={() => setSidebarOpen(true)}
        className="-m-2.5 p-2.5 text-gray-400 lg:hidden"
      >
        <span className="sr-only">Open sidebar</span>
        <Bars3Icon aria-hidden="true" className="size-6" />
      </button>
      <div className="flex-1 text-sm/6 font-semibold text-white">Dashboard</div>
      <a href="#">
        <span className="sr-only">Your profile</span>
        <img
          alt=""
          src="2.png"
          className="size-8 rounded-full bg-gray-800"
        />
      </a>
    </div>

    <main className="lg:pl-20">
    <div className="p-4 sm:p-6">
      <div className="flex items-center justify-between mb-3 p-3 rounded-2xl border border-white/40 bg-white/70 backdrop-blur-xl shadow-md">
        <h1 className="text-xl font-bold text-slate-800 font-bebas tracking-wide">Training Statistics</h1>
        {!openRec ? (
          <button
            data-component="training-stats-recommendations"
            data-feature="show"
            onClick={() => setOpenRec(true)}
            className="bg-sky-500 text-white px-3 py-1.5 text-xs font-semibold rounded-lg hover:bg-sky-600 focus:outline-none shadow-sm transition-colors"
          >Training Recommendations</button>
        ) : (
          <button
            data-component="training-stats-recommendations"
            data-feature="hide"
            onClick={() => setOpenRec(false)}
            className="bg-red-500 text-white px-3 py-1.5 text-xs font-semibold rounded-lg hover:bg-red-600 focus:outline-none shadow-sm transition-colors"
          >Hide Recommendations</button>
        )}
      </div>

      <dl className="mt-3 grid grid-cols-2 gap-3">
        {stats.map((item) => (
          <div
            key={item.id}
            className="flex items-center gap-3 rounded-xl border border-white/40 bg-white/70 backdrop-blur-xl px-4 py-3 shadow-md"
          >
            <div className="flex-shrink-0 rounded-lg bg-indigo-500 p-2 shadow-sm">
              <item.icon aria-hidden="true" className="size-5 text-white" />
            </div>
            <div>
              <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">{item.name}</p>
              <p className="text-xl font-bold text-slate-900">{item.stat}</p>
            </div>
          </div>
        ))}
      </dl>

      <div className="grid grid-cols-1 mt-4 gap-3">
        
        {trainingCards.map((card) => (
          <div key={card.trainingId} className="rounded-xl border border-white/40 bg-white/70 backdrop-blur-xl shadow-md p-3 sm:p-4 overflow-x-auto">
            <div className="flex items-center justify-between flex-wrap gap-2">
              <h2 className="text-sm font-bold text-slate-800">{card.trainingTitle}</h2>
              <div className="flex gap-2 flex-shrink-0">
                <button
                  data-component="training-stats-card-action"
                  data-feature={`details-${card.trainingId}`}
                  onClick={() =>
                    setOpenTrainingId(
                      openTrainingId === card.trainingId ? null : card.trainingId
                    )
                  }
                  className="px-3 py-1.5 text-xs font-semibold bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none shadow-sm transition-colors"
                >
                  {openTrainingId === card.trainingId ? 'Hide Details' : 'View Details'}
                </button>
                <button
                  data-component="training-stats-card-action"
                  data-feature={`graph-${card.trainingId}`}
                  onClick={() => setGraph(openTrainingId === card.trainingId ? null : card.trainingId)}
                  className="px-3 py-1.5 text-xs font-semibold bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 focus:outline-none shadow-sm transition-colors">
                  View Graphs
                </button>
              </div>
            </div>
            {graph === card.trainingId && (
              <HeatMap trainingId={card.trainingId} trainingCards={trainingCards} />
            )}



            {openTrainingId === card.trainingId && (
  <div className="mt-3 flow-root">
    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        <div className="overflow-hidden shadow ring-1 ring-black/5 bg-white/85 backdrop-blur-md sm:rounded-xl">
          <h3 className="px-4 py-3 bg-slate-100 text-sm font-semibold text-slate-800">
            Staff Attempts for {card.trainingTitle}
          </h3>
          <table className="min-w-full divide-y divide-gray-300">
            <thead className="bg-slate-50">
              <tr>
                <th
                  scope="col"
                  className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                >
                  Staff Name
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  Score
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  Attempt #
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  Date
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  Difficulty
                </th>
                
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 bg-white/90">
              {card.results
                .flatMap((result) =>
                  result.attempts.map((attempt) => ({
                    staffName: result.staffName,
                    score: attempt.score,
                    attemptNumber: attempt.attempts,
                    createdAt: attempt.createdAt,
                    difficulty: attempt.difficulty,
                    questionNumber: attempt.questionNumber,
                  }))
                )
                .map((item, idx) => (
                  <tr key={idx}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                      {item.staffName}
                    </td>
                    <td className={`whitespace-nowrap px-3 py-4 text-sm font-semibold 
  ${parseInt(item.score) / parseInt(item.questionNumber) >= 0.8 ? "text-emerald-500" : "text-red-500"}`}>
  {parseInt(item.score)}/{parseInt(item.questionNumber)} 
  {" "}
  {parseInt(item.score) / parseInt(item.questionNumber) >= 0.8 ? "PASS" : "FAIL"}
</td>

                    <td className="whitespace-nowrap px-3 py-4 text-sm text-slate-700">
                      {item.attemptNumber}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-slate-700">
                      {new Date(item.createdAt).toLocaleString()}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-slate-700">
                      {item.difficulty}
                    </td>
                  
                  </tr>
                ))}
            </tbody>
          </table>
          {/* You can also include your existing missing staff table below */}
          <div className="mt-8 px-3 pb-3">
      <TaskManager />
            
            {missingTraining.filter((m) => m.trainingId == card.trainingId).length > 0 ? (
  <ul className="list-disc pl-6 mt-2 mb-2 p-4 rounded-xl border border-amber-200 bg-amber-50 inline-block">
    <h3 className="text-lg font-semibold text-amber-800 mt-1 mb-1">Missing Staff</h3>
    {missingTraining
      .filter((m) => m.trainingId == card.trainingId)
      .map((m, index) => (
        <li key={index} className="text-sm text-amber-900">
          {m.staffName}
        </li>
      ))}
  </ul>
) : (
  <p className="p-4 text-sm text-slate-500">No missing staff.</p>
)}

          </div>
          
        </div>
      </div>
    </div>
  </div>
)}

          </div>
        ))}
      </div>
    </div>
      


      </main>
    </div>


</>

        )


        

 
}
